import { useState } from 'react'
import {
  ReportImageModal,
  ImageReportedModal,
} from '../../containers/vehicle/modals/image-reporting'
import { VIEWS } from '../../containers/auth/modals'
import { useAuth } from '../../contexts/auth'
import { Desktop, Mobile } from '../media'
import DesktopGallery from './desktop'
import MobileGallery from './mobile'

const REPORT_VIEWS = {
  ReportImage: 1,
  ImageReported: 2,
  ImageAlreadyReported: 3,
}

const REPORT_IMAGE_STATUS = {
  [REPORT_VIEWS.ImageReported]: 'Image reported',
  [REPORT_VIEWS.ImageAlreadyReported]: 'You already reported this image',
}

export default function Gallery({ initialIndex = 0, images, isDealer }) {
  const [{ isAuthenticated }, { setAuthModal }] = useAuth()
  const [toBeReportedImage, setToBeReportedImage] = useState({
    modal: null,
    photoType: null,
    photoId: null,
  })

  const handleReportClick = (photoType, photoId) =>
    isAuthenticated
      ? setToBeReportedImage({ modal: REPORT_VIEWS.ReportImage, photoType, photoId })
      : setAuthModal({ open: true, view: VIEWS.Login })

  return (
    <>
      <Desktop>
        <DesktopGallery
          images={images}
          initialIndex={initialIndex}
          onReportClick={handleReportClick}
          isDealer={isDealer}
        />
      </Desktop>
      <Mobile>
        <MobileGallery
          images={images}
          initialIndex={initialIndex}
          onReportClick={handleReportClick}
        />
      </Mobile>

      {toBeReportedImage.modal === REPORT_VIEWS.ReportImage && (
        <ReportImageModal
          photoType={toBeReportedImage.photoType}
          photoId={toBeReportedImage.photoId}
          onClose={() => setToBeReportedImage({ modal: false, photoType: null, photoId: null })}
          onSuccess={() =>
            setToBeReportedImage({
              modal: REPORT_VIEWS.ImageReported,
              photoType: null,
              photoId: null,
            })
          }
          onError={() =>
            setToBeReportedImage({
              modal: REPORT_VIEWS.ImageAlreadyReported,
              photoType: null,
              photoId: null,
            })
          }
        />
      )}

      {[REPORT_VIEWS.ImageReported, REPORT_VIEWS.ImageAlreadyReported].includes(
        toBeReportedImage.modal,
      ) && (
        <ImageReportedModal
          status={REPORT_IMAGE_STATUS[toBeReportedImage.modal]}
          onClose={() => setToBeReportedImage({ modal: false, photoType: null, photoId: null })}
        />
      )}
    </>
  )
}
